module.exports = __webpack_public_path__ + "img/5391d95.webp";